import React, { useState, useEffect } from 'react';
import WeChatRadar from './WeChatRadar';
import XHSRadar from './XHSRadar';
import { Compass, Zap, Target, CheckCircle2, XCircle, Crosshair, Crown, Loader2, Calendar, LayoutGrid, Sparkles } from 'lucide-react';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

const PLATFORMS = [
  { id: 'douyin', name: '抖音', activeColor: 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900', hover: 'hover:bg-slate-200 dark:hover:bg-slate-700' },
  { id: 'xhs', name: '小红书', activeColor: 'bg-red-500 text-white shadow-md shadow-red-500/20', hover: 'hover:bg-red-50 dark:hover:bg-red-500/20 hover:text-red-600' },
  { id: 'wechat', name: '微信', activeColor: 'bg-emerald-500 text-white shadow-md shadow-emerald-500/20', hover: 'hover:bg-emerald-50 dark:hover:bg-emerald-500/20 hover:text-emerald-600' },
  { id: 'weibo', name: '微博', activeColor: 'bg-orange-500 text-white shadow-md shadow-orange-500/20', hover: 'hover:bg-orange-50 dark:hover:bg-orange-500/20 hover:text-orange-600' },
  { id: 'bilibili', name: 'B站', activeColor: 'bg-blue-500 text-white shadow-md shadow-blue-500/20', hover: 'hover:bg-blue-50 dark:hover:bg-blue-500/20 hover:text-blue-600' },
  { id: 'baidu', name: '百度', activeColor: 'bg-blue-600 text-white shadow-md shadow-blue-600/20', hover: 'hover:bg-blue-50 dark:hover:bg-blue-600/20 hover:text-blue-700' },
];

const MOCK_DATA = {
  douyin: {
    categories: [
      { id: 'shoes', name: '女鞋', priority: '首选', score: 5, action: '重仓投入', desc: '明星效应最强品类，ROI最高', color: 'from-rose-500 to-pink-600', bg: 'bg-rose-500/10', text: 'text-rose-600 dark:text-rose-400', border: 'border-rose-500/20' },
      { id: 'bracelet', name: '手链', priority: '次选', score: 4, action: '差异化竞争', desc: '猎奇话题易出圈，互动两极分化', color: 'from-amber-500 to-orange-600', bg: 'bg-amber-500/10', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-500/20' },
      { id: 'necklace', name: '项链', priority: '次选', score: 4, action: '场景化包装', desc: '艺术展与沉浸式体验爆发力强', color: 'from-amber-500 to-orange-600', bg: 'bg-amber-500/10', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-500/20' },
      { id: 'bangle', name: '手镯', priority: '可选', score: 3, action: '深耕垂类', desc: '传统文化与知识科普易获高赞', color: 'from-blue-500 to-indigo-600', bg: 'bg-blue-500/10', text: 'text-blue-600 dark:text-blue-400', border: 'border-blue-500/20' },
    ],
    formulas: {
      'shoes': {
        title: '明星代言 + 反差穿搭场景', roi: '40万+ 赞', likes: '13,752 (均)',
        do: ['首选明星代言内容', '反差感剧情 (普通人+奢品)', '穿搭场景展示 (街拍/日常)'], dont: ['避免纯回收估价内容 (互动极低)']
      },
      'bracelet': {
        title: '猎奇话题 + 二手回收', roi: '40万+ 赞', likes: '12,214 (均)',
        do: ['二手回收话题 (猎奇+信息差)', '品牌历史/冷知识科普'], dont: ['单纯穿搭教程 (容易被淹没)']
      },
      'necklace': {
        title: '艺术展/快闪 + 沉浸式', roi: '30万+ 赞', likes: '11,534 (均)',
        do: ['艺术展/快闪店沉浸式体验', '明星红毯造型解析'], dont: ['干瘪的产品平铺展示']
      },
      'bangle': {
        title: '传统文化 + 知识科普', roi: '25万+ 赞', likes: '10,156 (均)',
        do: ['传统文化+现代设计 (国潮)', '送礼指南 (节日场景)'], dont: ['缺乏故事包装的硬广']
      }
    },
    brands: [
      { brand: 'Dior', strength: '女鞋、项链', opportunity: '手镯、围巾', tactic: '强化明星效应，利用泛娱乐流量扩展品类' },
      { brand: 'Gucci', strength: '男鞋、手镯', opportunity: '手链、项链', tactic: '国潮路线与文化科普持续深化' },
    ]
  },
  xhs: {
    categories: [
      { id: 'shoes', name: '女鞋', priority: '次选', score: 3, action: '审美升级', desc: '小红书鞋控挑剔，需极高图文审美', color: 'from-amber-500 to-orange-600', bg: 'bg-amber-500/10', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-500/20' },
      { id: 'bracelet', name: '手链', priority: '首选', score: 5, action: '重仓投入', desc: '氛围感极强，千金风/老钱风核心单品', color: 'from-rose-500 to-pink-600', bg: 'bg-rose-500/10', text: 'text-rose-600 dark:text-rose-400', border: 'border-rose-500/20' },
      { id: 'necklace', name: '项链', priority: '首选', score: 5, action: '场景化包装', desc: '叠戴教程与OOTD点睛之笔', color: 'from-rose-500 to-pink-600', bg: 'bg-rose-500/10', text: 'text-rose-600 dark:text-rose-400', border: 'border-rose-500/20' },
      { id: 'bangle', name: '手镯', priority: '可选', score: 4, action: '保值科普', desc: '保值率与二手行情干货受欢迎', color: 'from-blue-500 to-indigo-600', bg: 'bg-blue-500/10', text: 'text-blue-600 dark:text-blue-400', border: 'border-blue-500/20' },
    ],
    formulas: {
      'shoes': {
        title: '静奢风OOTD + 原相机细节', roi: '5万+ 藏赞', likes: '4,520 (均)',
        do: ['高像素材质细节特写', '九宫格生活方式街拍 (咖啡馆/画廊)', '打卡场景穿搭'], dont: ['剧情演绎、土味反差 (严重掉粉)']
      },
      'bracelet': {
        title: '千金首饰盒 + 沉浸式开箱', roi: '10万+ 藏赞', likes: '8,214 (均)',
        do: ['ASMR沉浸式拆包装', '与腕表混搭叠戴教程', '情绪价值文案 (取悦自己)'], dont: ['粗糙的画质，背景杂乱']
      },
      'necklace': {
        title: '老钱风 V领叠戴法则', roi: '8万+ 藏赞', likes: '6,534 (均)',
        do: ['颈部线条展示', '职场/约会等多场景切换展示'], dont: ['只发一张图，没有穿搭干货']
      },
      'bangle': {
        title: '买错亏一半！保值率干货', roi: '12万+ 藏赞', likes: '9,156 (均)',
        do: ['不同材质氧化对比', '二手保值率红黑榜整理 (表格呈现)'], dont: ['直接带货或微商风文案']
      }
    },
    brands: [
      { brand: 'Chanel', strength: '项链、手链', opportunity: '女鞋', tactic: '延续极简美学，主打「精致打工人」通勤穿搭' },
      { brand: 'Hermès', strength: '手镯、丝巾', opportunity: '手链', tactic: '输出配货攻略与保值行情，做知识分享型内容' },
    ]
  }
};

export default function SeoEcology() {
  const [viewMode, setViewMode] = useState('insights');
  const [platform, setPlatform] = useState('douyin');
  const [activeCategory, setActiveCategory] = useState('shoes');
  const [brandProjectId, setBrandProjectId] = useState('');
  
  const [reports, setReports] = useState({});
  const [loading, setLoading] = useState(true);
  
  const [showModal, setShowModal] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [dateRange, setDateRange] = useState('30');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedPlatforms, setSelectedPlatforms] = useState(['douyin', 'xhs']);

  // Fetch brand context
  useEffect(() => {
    const fetchGlobalBrand = () => {
      const bid = localStorage.getItem('globalBrand');
      if (bid && bid !== 'all' && bid !== 'undefined') {
        setBrandProjectId(bid);
      }
    };
    fetchGlobalBrand();
    window.addEventListener('globalFilterChange', fetchGlobalBrand);
    return () => window.removeEventListener('globalFilterChange', fetchGlobalBrand);
  }, []);

  // Fetch report when brand or platform changes
  useEffect(() => {
    if (!brandProjectId) return;
    
    // Check if we already have it in state
    if (reports[platform]) {
       // if we have it, ensure active category is safe
       const data = reports[platform];
       if (Array.isArray(data.categories) && data.categories.length > 0 && !(data.formulas && data.formulas[activeCategory])) {
           setActiveCategory(data.categories[0]?.id || 'shoes');
       }
       return;
    }

    setLoading(true);
    axios.get(`${API_URL}/seo-ecology`, { params: { brandProjectId, platform: PLATFORMS.find(p=>p.id===platform)?.name || platform } })
      .then(res => {
        if (res.data.success && res.data.data) {
           const reportData = res.data.data.reportData;
           setReports(prev => ({ ...prev, [platform]: reportData }));
           if (Array.isArray(reportData.categories) && reportData.categories.length > 0) {
               setActiveCategory(reportData.categories[0]?.id || 'shoes');
           }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [brandProjectId, platform]);

  const handleGenerate = async () => {
    if (!brandProjectId) return alert("请先在顶部选择一个具体项目");
    if (selectedPlatforms.length === 0) return alert("至少选择一个阵地");
    
    setIsGenerating(true);
    const platformNames = selectedPlatforms.map(pId => PLATFORMS.find(p=>p.id === pId).name);
    
    try {
      const res = await axios.post(`${API_URL}/seo-ecology/generate`, {
         brandProjectId,
         platforms: platformNames,
         dateRange,
         startDate,
         endDate
      });
      if (res.data.success) {
         setShowModal(false);
         // Clear cache and refetch current
         setReports({});
         setPlatform(selectedPlatforms[0]); 
      }
    } catch (e) {
      alert("生成失败，可能大模型响应超时，请重试");
    } finally {
      setIsGenerating(false);
    }
  };

  const currentData = reports[platform] || MOCK_DATA[platform] || MOCK_DATA['douyin'];
  const categories = Array.isArray(currentData.categories) ? currentData.categories : [];
  const formulas = currentData.formulas || {};
  const brands = Array.isArray(currentData.brands) ? currentData.brands : [];

  if (!formulas[activeCategory] && categories.length > 0) {
    // delay setter to avoid render warnings is better but this is fine for now
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 pb-12 transition-colors">
      <div className="max-w-full px-4 sm:px-6 lg:px-8 py-8">
        
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-6 space-y-4 lg:space-y-0">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100 flex items-center gap-2">
              <Compass className="w-6 h-6 text-emerald-500" />
              内容生态解析
            </h1>
            <p className="text-sm text-gray-500 dark:text-slate-400 mt-2">
              基于 AI 深度大模型，穿透浅层排名数据，解码高点赞背后的核心内容公式与战略部署方向。
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-slate-400 hidden sm:block">最后研判时间: 今日 08:30</span>
            <button onClick={() => setShowModal(true)} className="px-4 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors shadow-sm active:scale-95">
              重新生成研判报告
            </button>
          </div>
        </div>

        
        
        {/* View Switcher & Global Filters */}
        <div className="flex justify-between items-center border-b border-slate-200 dark:border-slate-700 mb-6">
          <div className="flex overflow-x-auto hide-scrollbar">
            <button onClick={() => setViewMode('insights')} className={`px-6 py-3 font-semibold text-sm transition-all border-b-2 whitespace-nowrap ${viewMode === 'insights' ? 'border-emerald-500 text-emerald-600 dark:text-emerald-400' : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'}`}>
              全域生态洞察 (AI)
            </button>
            <button onClick={() => setViewMode('wechat')} className={`px-6 py-3 font-semibold text-sm transition-all border-b-2 whitespace-nowrap ${viewMode === 'wechat' ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400' : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'}`}>
              微信全域舆情雷达
            </button>
            <button onClick={() => setViewMode('xhs')} className={`px-6 py-3 font-semibold text-sm transition-all border-b-2 whitespace-nowrap ${viewMode === 'xhs' ? 'border-red-500 text-red-600 dark:text-red-400' : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'}`}>
              小红书舆情与占位雷达
            </button>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex items-center">
              <div className="relative">
                <Calendar className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 z-10 pointer-events-none" />
                <select 
                value={dateRange}
                onChange={(e) => setDateRange(e.target.value)}
                className="pl-9 pr-8 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-700 dark:text-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 appearance-none font-medium shadow-sm"
              >
                <option value="1">🚨 今日实时 (24H)</option>
                <option value="7">🟡 近 7 天</option>
                <option value="30">🔵 近 30 天</option>
                <option value="all">📅 全部历史</option>
                <option value="custom">📅 自定义日期</option>
              </select>
              </div>
              {dateRange === 'custom' && (
                <div className="flex items-center gap-2 ml-2 animate-in fade-in duration-200">
                  <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="px-2 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-700 dark:text-slate-300 focus:outline-none focus:ring-1 focus:ring-emerald-500" />
                  <span className="text-slate-400">-</span>
                  <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="px-2 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-700 dark:text-slate-300 focus:outline-none focus:ring-1 focus:ring-emerald-500" />
                </div>
              )}
            </div>
          </div>
        </div>

        {viewMode === 'wechat' && <WeChatRadar brandProjectId={brandProjectId} dateRange={dateRange} startDate={startDate} endDate={endDate} />}
        {viewMode === 'xhs' && <XHSRadar brandProjectId={brandProjectId} dateRange={dateRange} startDate={startDate} endDate={endDate} />}
        
        <div style={{ display: viewMode === 'insights' ? 'block' : 'none' }}>
        {/* Platform Global Tabs */}
        <div className="bg-white dark:bg-slate-800/80 p-2 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700/50 mb-8 flex flex-wrap gap-2 w-fit">
          {PLATFORMS.map(p => (
            <button
              key={p.id}
              onClick={() => setPlatform(p.id)}
              className={`px-5 py-2 rounded-lg text-sm font-bold transition-all duration-200 ${platform === p.id ? p.activeColor : ('text-slate-500 bg-transparent ' + p.hover)}`}
            >
              {p.name}
            </button>
          ))}
        </div>

        {/* Module 1: 品类部署战略 (Category Allocation) */}
        <div className="bg-white dark:bg-slate-800/60 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm mb-6">
          <h3 className="text-lg font-bold text-gray-900 dark:text-slate-100 flex items-center mb-6">
            <Target className="w-5 h-5 mr-2 text-rose-500" />
            全品类兵力部署矩阵 (Category Strategy Matrix)
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {(categories || []).filter(Boolean).map(cat => (
              <div key={cat.id} className={`p-5 rounded-lg border ${cat.border} ${cat.bg} flex flex-col relative overflow-hidden transition-all hover:shadow-md cursor-pointer ${activeCategory === cat.id ? 'ring-2 ring-offset-2 ring-emerald-500 dark:ring-offset-slate-900' : ''}`} onClick={() => setActiveCategory(cat.id)}>
                <div className="flex justify-between items-start mb-3">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-slate-800 dark:text-slate-200">{cat.name}</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-semibold bg-white/50 dark:bg-black/20 ${cat.text}`}>{cat.priority}</span>
                  </div>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className={`w-2 h-4 rounded-sm ${i < cat.score ? ('bg-gradient-to-t ' + cat.color) : 'bg-slate-200 dark:bg-slate-700'}`} />
                    ))}
                  </div>
                </div>
                <div className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
                  战略建议: <span className={cat.text}>{cat.action}</span>
                </div>
                <div className="text-xs text-slate-500 dark:text-slate-400 mt-auto pt-3 border-t border-slate-200/50 dark:border-slate-700/50">
                  {cat.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* Module 2: 爆款解码机 */}
          <div className="lg:col-span-2 bg-white dark:bg-slate-800/60 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm flex flex-col">
            <div className="flex justify-between items-center mb-6 border-b border-slate-100 dark:border-slate-700 pb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-slate-100 flex items-center">
                <Zap className="w-5 h-5 mr-2 text-amber-500" />
                爆款公式解码机 (Viral Formula Engine)
              </h3>
            </div>

            {formulas[activeCategory] ? (
              <div className="flex-1 flex flex-col gap-6">
                {/* Formula Display */}
                <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl p-6 lg:p-8 relative overflow-hidden shadow-lg border border-slate-700">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none"></div>
                  <div className="text-amber-400 text-xs font-bold tracking-widest uppercase mb-3 flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
                    当前阵地最佳内容组合
                  </div>
                  <div className="text-2xl lg:text-3xl font-black text-white tracking-tight leading-tight">
                    {formulas[activeCategory].title}
                  </div>
                  <div className="flex gap-8 mt-8 border-t border-slate-700/50 pt-5">
                    <div>
                      <div className="text-slate-400 text-xs mb-1">预期互动上限</div>
                      <div className="text-emerald-400 text-2xl font-bold">{formulas[activeCategory].roi}</div>
                    </div>
                    <div>
                      <div className="text-slate-400 text-xs mb-1">大盘平均互动</div>
                      <div className="text-slate-200 text-2xl font-bold">{formulas[activeCategory].likes}</div>
                    </div>
                  </div>
                </div>

                {/* Do & Don't */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-emerald-50 dark:bg-emerald-900/10 border border-emerald-100 dark:border-emerald-800/30 rounded-lg p-5">
                    <div className="flex items-center gap-2 text-emerald-600 dark:text-emerald-400 font-bold mb-4 border-b border-emerald-100 dark:border-emerald-800/30 pb-2">
                      <CheckCircle2 className="w-5 h-5" /> 推荐动作 (DOs)
                    </div>
                    <ul className="space-y-3">
                      {(Array.isArray(formulas[activeCategory].do) ? formulas[activeCategory].do : []).map((txt, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
                          <span className="mt-1 w-1.5 h-1.5 rounded-full bg-emerald-400 flex-shrink-0"></span>
                          {txt}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-rose-50 dark:bg-rose-900/10 border border-rose-100 dark:border-rose-800/30 rounded-lg p-5">
                    <div className="flex items-center gap-2 text-rose-600 dark:text-rose-400 font-bold mb-4 border-b border-rose-100 dark:border-rose-800/30 pb-2">
                      <XCircle className="w-5 h-5" /> 避坑预警 (DON'Ts)
                    </div>
                    <ul className="space-y-3">
                      {(Array.isArray(formulas[activeCategory].dont) ? formulas[activeCategory].dont : []).map((txt, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
                          <span className="mt-1 w-1.5 h-1.5 rounded-full bg-rose-400 flex-shrink-0"></span>
                          {txt}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {/* Module 3: 机会绞肉机 (Brand Opportunity Matrix) */}
          <div className="bg-white dark:bg-slate-800/60 backdrop-blur-xl border border-gray-200 dark:border-slate-700/50 rounded-xl p-6 shadow-sm">
            <h3 className="text-lg font-bold text-gray-900 dark:text-slate-100 flex items-center mb-6">
              <Crosshair className="w-5 h-5 mr-2 text-indigo-500" />
              本品 vs 竞品：生态站位图
            </h3>
            
            <div className="space-y-4">
              {(brands || []).filter(Boolean).map((item, idx) => (
                <div key={idx} className="p-4 rounded-lg bg-slate-50 dark:bg-slate-800/80 border border-slate-100 dark:border-slate-700 hover:shadow-sm transition-shadow">
                  <div className="flex justify-between items-center mb-3">
                    <div className="font-bold text-base text-slate-800 dark:text-slate-200 flex items-center gap-2">
                      {idx === 0 && <Crown className="w-4 h-4 text-amber-500" />}
                      {item.brand}
                    </div>
                  </div>
                  
                  <div className="space-y-2 text-xs">
                    <div className="flex">
                      <span className="w-20 text-slate-500 dark:text-slate-400 font-medium shrink-0">优势护城河</span>
                      <span className="text-slate-700 dark:text-slate-300">{item.strength}</span>
                    </div>
                    <div className="flex">
                      <span className="w-20 text-indigo-500 dark:text-indigo-400 font-medium shrink-0">错位机会点</span>
                      <span className="text-slate-700 dark:text-slate-300">{item.opportunity}</span>
                    </div>
                    <div className="flex pt-3 mt-2 border-t border-slate-200 dark:border-slate-700 border-dashed">
                      <span className="w-20 text-emerald-500 dark:text-emerald-400 font-bold shrink-0">AI 推荐对策</span>
                      <span className="text-slate-800 dark:text-slate-200 font-medium leading-relaxed">{item.tactic}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    
      {/* Settings Modal */}
      
        </div>

        {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 dark:bg-black/60 backdrop-blur-sm">
          <div className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden border border-slate-200 dark:border-slate-700 animate-in fade-in zoom-in duration-200">
            <div className="p-6 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center">
              <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <Zap className="w-5 h-5 text-emerald-500" />
                启动深度生态研判
              </h3>
              <button onClick={() => !isGenerating && setShowModal(false)} className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">
                <XCircle className="w-6 h-6" />
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              <div className="space-y-3">
                <label className="text-sm font-bold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-slate-400" />
                  研判数据时间范围
                </label>
                <div className="grid grid-cols-3 gap-3">
                  {[
                    { label: '最近 7 天', value: '7' },
                    { label: '最近 30 天', value: '30' },
                    { label: '全部时间', value: 'all' }
                  ].map(opt => (
                    <button 
                      key={opt.value}
                      onClick={() => setDateRange(opt.value)}
                      className={`py-2 rounded-lg text-sm font-medium border transition-colors ${dateRange === opt.value ? 'border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400' : 'border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700/50'}`}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="space-y-3">
                <label className="text-sm font-bold text-slate-700 dark:text-slate-300 flex items-center gap-2">
                  <LayoutGrid className="w-4 h-4 text-slate-400" />
                  研判阵地选择 (多选)
                </label>
                <div className="flex flex-wrap gap-2">
                  {PLATFORMS.map(p => {
                    const isSelected = selectedPlatforms.includes(p.id);
                    return (
                      <button
                        key={p.id}
                        onClick={() => {
                           if(isSelected) setSelectedPlatforms(prev => prev.filter(x => x !== p.id));
                           else setSelectedPlatforms(prev => [...prev, p.id]);
                        }}
                        className={`px-3 py-1.5 rounded-md text-sm border transition-colors ${isSelected ? 'border-indigo-500 bg-indigo-50 text-indigo-700 dark:bg-indigo-500/20 dark:text-indigo-400' : 'border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400 dark:hover:bg-slate-700/50'}`}
                      >
                        {p.name}
                      </button>
                    )
                  })}
                </div>
              </div>
              
              <div className="bg-slate-50 dark:bg-slate-900/50 p-4 rounded-lg border border-slate-100 dark:border-slate-800 text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
                <p>⚠️ 注意：深度研判将调用 DeepSeek 大模型实时运算，单个平台约需消耗 <strong>1500 Tokens</strong>，分析耗时约 <strong>15-30秒</strong>，请耐心等待。</p>
              </div>
            </div>

            <div className="p-6 border-t border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80">
              <button 
                onClick={handleGenerate}
                disabled={isGenerating}
                className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all flex justify-center items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isGenerating ? (
                  <><Loader2 className="w-5 h-5 animate-spin" /> 大模型全速炼丹中...</>
                ) : (
                  <><Sparkles className="w-5 h-5" /> 消耗 1500 Tokens，立即启动</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
